function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.57674 10.5284L10.7415 12.8812L10.0938 14.7887L7.44323 11.8735L3.18183 16.5604L1.97584 15.234L6.30967 10.5237C5.24435 9.22073 4.39205 7.77715 3.7699 6.24924H5.47443C5.9943 7.36473 6.65057 8.41928 7.44319 9.38946C8.67046 7.88963 9.56963 6.17424 10.1449 4.36512H0.625V2.49976H6.59092V0.625H8.29549V2.49976H14.2615V4.37918H11.7643C11.1421 6.5914 10.0853 8.68173 8.60231 10.5002L8.57674 10.5284ZM13.8352 8.12654H15.5398L19.375 19.375H17.6704L16.7116 16.5629H12.6633L11.7045 19.375H9.99994L13.8352 8.12654ZM14.6875 10.6246L13.3025 14.6881H16.0725L14.6875 10.6246Z",
  fill: "currentColor"
});

var SvgIcLanguage = function SvgIcLanguage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcLanguage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_language.d2146270.svg";
export { ForwardRef as ReactComponent };